import DadosBasicosDefaultFormConnected from "./DadosBasicosDefaultForm.connected";
import DadosEstadoCivilDefaultFormConnected from "./DadosEstadoCivilDefaultForm.connected";
import DadosClienteDefaultFormConnected from "./DadosClienteDefaultForm.connected";
import DadosOutrasInformacoesDefaultFormConnected from "./DadosOutrasInformacoesDefaultForm.connected";

const FluxoDefault = (props) => {
  return (
    <>
      {props.step === 0 && <DadosClienteDefaultFormConnected {...props} />}
      {props.step === 1 && <DadosBasicosDefaultFormConnected {...props} />}
      {props.step === 2 && <DadosEstadoCivilDefaultFormConnected {...props} />}
      {props.step === 3 && (
        <DadosOutrasInformacoesDefaultFormConnected {...props} />
      )}
    </>
  );
};

export default FluxoDefault;
